import { render, staticRenderFns } from "./LocationSettingsNavbar.vue?vue&type=template&id=51a051a0&scoped=true"
import script from "./LocationSettingsNavbar.vue?vue&type=script&lang=js"
export * from "./LocationSettingsNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a051a0",
  null
  
)

export default component.exports